module.exports = __webpack_public_path__ + "img/student.b0054a50.svg";